"use client";

import { IconCheckOutline18, IconDatabaseOutline18 } from "nucleo-ui-outline-18";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CreateTableModal } from "@/app/(v2)/databases/_components/CreateTableModal";
import type { ColumnDef } from "@/app/(v2)/databases/_components/CreateTableModal";
interface DatabaseTableWidgetProps {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  properties?: {
    tableName?: string;
    columns?: ColumnDef[];
  };
}
export function DatabaseTableWidget({
  label,
  description,
  value,
  onChange,
  properties
}: DatabaseTableWidgetProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const created = !!value;
  return <div className="space-y-2">
      {label && <label className="field-label">{label}</label>}
      {description && <p className="body-sm text-ds-text-muted">{description}</p>}
      {created ? <div className="flex items-center gap-2">
          <IconCheckOutline18 className="h-4 w-4 text-emerald-600" />
          <span className="body-sm-medium text-emerald-700 dark:text-emerald-300">
            Table <code className="font-mono">{value}</code> created
          </span>
        </div> : <div className="space-y-3">
          {properties?.tableName && <div>
              <span className="body-sm text-ds-text-muted">Proposed table:</span>
              <code className="ml-2 font-mono text-sm font-medium">{properties.tableName}</code>
            </div>}
          {properties?.columns && properties.columns.length > 0 && <div className="overflow-x-auto">
              <table className="w-full text-left text-xs">
                <thead>
                  <tr className="border-ds-border-default border-b">
                    <th scope="col" className="text-ds-text-muted pb-1.5 pr-4 font-medium">
                      Column
                    </th>
                    <th scope="col" className="text-ds-text-muted pb-1.5 pr-4 font-medium">
                      Type
                    </th>
                    <th scope="col" className="text-ds-text-muted pb-1.5 font-medium">
                      Constraints
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {properties.columns.map((col, i) => <tr key={i} className="border-ds-neutral-100 dark:border-ds-neutral-800 border-b last:border-0">
                      <td className="py-1.5 pr-4 font-mono">{col.name}</td>
                      <td className="text-ds-text-muted py-1.5 pr-4">{col.type}</td>
                      <td className="text-ds-text-muted py-1.5">
                        {[col.primaryKey && "PK", col.notNull && "NOT NULL", col.defaultValue && `DEFAULT ${col.defaultValue}`].filter(Boolean).join(", ") || "-"}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
          <Button type="button" size="sm" onClick={() => setModalOpen(true)}>
            <IconDatabaseOutline18 className="mr-1.5 h-3.5 w-3.5" />
            Create Table
          </Button>
        </div>}
      {modalOpen && <CreateTableModal open={modalOpen} onOpenChange={setModalOpen} initialTableName={properties?.tableName} initialColumns={properties?.columns} onCreated={tableName => onChange(tableName)} />}
    </div>;
}